// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__qQBD6","col":"styles_col__1P1Q-","fulfillmentStatus":"styles_fulfillmentStatus__CNSXR","emailCol":"styles_emailCol__3ATGV"};